import { z } from 'zod';
import type { RobotsFileToken } from '@sleed/bizcommerce-api';

const utf8 = new TextEncoder();

/** UTF-8 byte length — the server limit is in bytes, not characters (Greek letters take 2). */
export const utf8Bytes = (value: string) => utf8.encode(value).length;

/**
 * robots.txt editor form. Mirrors the server rules in `RobotsFileStore.Validate`
 * (non-blank, ≤ `maxContentBytes` UTF-8 bytes); the server remains authoritative.
 */
export function robotsFileSchema(maxContentBytes: number) {
	return z.object({
		content: z
			.string()
			.refine(v => v.trim().length > 0, 'system.robotsFile.errors.empty')
			.refine(v => maxContentBytes <= 0 || utf8Bytes(v) <= maxContentBytes, 'system.robotsFile.errors.tooLarge')
	});
}

export type RobotsFileFormValues = z.infer<ReturnType<typeof robotsFileSchema>>;

export const tokenToForm = (token: RobotsFileToken): RobotsFileFormValues => ({ content: token.content ?? '' });

export const formToToken = (form: RobotsFileFormValues): RobotsFileToken => ({ content: form.content });
